// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.wave{
	position: fixed;
	bottom: 0;
	left: 0;
	height: 100%;
	z-index: -1;
}

.container{
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap :7rem;
    padding: 0 2rem;
}

.img{
	display: flex;
	justify-content: flex-end;
	align-items: center;
}

.login-content{
	display: flex;
	justify-content: flex-end;
	align-items: center;
	text-align: center;
}

.img img{
	width: 1500px;
	margin-bottom: 120px;
	margin-left: 30px;
}

form{
	width: 360px;
	display: flex;
	flex-direction: column;
	
}

.error{
	padding: 20px;
	margin-bottom: 20px;
	background-color: rgb(254 202 202);
	border:1px solid rgb(244, 158, 158);
	animation: moveLeftToRight 1s ease-in-out ;
	display: flex;
	color: darkslategray;
	justify-content: space-between;
	align-items: center;
}

@keyframes moveLeftToRight {
	0% {
	  transform: translateX(100px);
	}
	100% {
	  transform: translateX(0px); /* Adjust the distance as needed */
	}
  }


.login-content img{
    height: 100px;
	
}

.login-content h2{
	margin: 15px 0;
	color: #333;
	text-transform: uppercase;
	font-size: 2.9rem;
}

.login-content .input-div{
	position: relative;
    display: grid;
    grid-template-columns: 7% 93%;
    margin: 25px 0;
    padding: 5px 0;
    border-bottom: 2px solid #d9d9d9;
}

.login-content .input-div.one{
	margin-top: 0;
}

.i{
	color: #d9d9d9;
	display: flex;
	justify-content: center;
	align-items: center;
}

.i i{
	transition: .3s;
}

.input-div > div{
    position: relative;
	height: 45px;
}

.input-div > div > h5{
	position: absolute;
	left: 10px;
	top: 50%;
	transform: translateY(-50%);
	color: #999;
	font-size: 18px !important;
	transition: .3s;
}

.input-div:before, .input-div:after{
	content: '';
	position: absolute;
	bottom: -2px;
	width: 0%;
	height: 2px;
	background-color: #38d39f;
	transition: .4s;
}

.input-div:before{
	right: 50%;
}

.input-div:after{
	left: 50%;
}

.input-div.focus:before, .input-div.focus:after{
	width: 50%;
}

.input-div.focus > div > h5{
	top: -5px;
	font-size: 15px;
}

.input-div.focus > .i > i{
	color: #38d39f;
}

.input-div > div > input{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	border: none;
	outline: none;
	background: none;
	padding: 0.5rem 0.7rem;
	font-size: 1.2rem;
	color: #555;
	font-family: 'poppins', sans-serif;
}

.input-div.pass{
	margin-bottom: 4px;
}

a{
	display: block;
	text-align: right;
	text-decoration: none;
	color: #999;
	font-size: 0.9rem;
	transition: .3s;
}

a:hover{
	color: #38d39f;
}

.btn{
	display: block;
	width: 100%;
	height: 50px;
	border-radius: 25px;
	outline: none;
	border: none;
	background-image: linear-gradient(to right, #32be8f, #38d39f, #32be8f);
	background-size: 200%;
	font-size: 1.2rem;
	color: #fff;
	font-family: 'Poppins', sans-serif;
	text-transform: uppercase;
	margin: 1rem 0;
	cursor: pointer;
	transition: .5s;
}
.btn:hover{
	background-position: right;
}


@media screen and (max-width: 1050px){
	.container{
		grid-gap: 5rem;
	}
}

@media screen and (max-width: 1000px){
	form{
		width: 290px;
	}

	.login-content h2{
        font-size: 2.4rem;
        margin: 8px 0;
	}

	.img img{
		width: 400px;
	}
}

@media screen and (max-width: 900px){
	.container{
		grid-template-columns: 1fr;
	}

	.img{
		display: none;
	}

	.wave{
		display: none;
	}

	.login-content{
		justify-content: center;
	}
}`, "",{"version":3,"sources":["webpack://./src/LoginPage.css"],"names":[],"mappings":";AACA;CACC,eAAe;CACf,SAAS;CACT,OAAO;CACP,YAAY;CACZ,WAAW;AACZ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,eAAe;AACnB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,oBAAoB;CACpB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,sBAAsB;;AAEvB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kCAAkC;CAClC,mCAAmC;CACnC,0CAA0C;CAC1C,aAAa;CACb,oBAAoB;CACpB,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC;GACE,4BAA4B;CAC9B;CACA;GACE,0BAA0B,EAAE,kCAAkC;CAChE;EACC;;;AAGF;IACI,aAAa;;AAEjB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,yBAAyB;CACzB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;IACf,aAAa;IACb,6BAA6B;IAC7B,cAAc;IACd,cAAc;IACd,gCAAgC;AACpC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;IACI,kBAAkB;CACrB,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,2BAA2B;CAC3B,WAAW;CACX,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,WAAW;CACX,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,gBAAgB;CAChB,sBAAsB;CACtB,iBAAiB;CACjB,WAAW;CACX,kCAAkC;AACnC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,qBAAqB;CACrB,WAAW;CACX,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,aAAa;CACb,YAAY;CACZ,sEAAsE;CACtE,qBAAqB;CACrB,iBAAiB;CACjB,WAAW;CACX,kCAAkC;CAClC,yBAAyB;CACzB,cAAc;CACd,eAAe;CACf,eAAe;AAChB;AACA;CACC,0BAA0B;AAC3B;;;AAGA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;QACO,iBAAiB;QACjB,aAAa;CACpB;;CAEA;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,0BAA0B;CAC3B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,uBAAuB;CACxB;AACD","sourcesContent":["\n.wave{\n\tposition: fixed;\n\tbottom: 0;\n\tleft: 0;\n\theight: 100%;\n\tz-index: -1;\n}\n\n.container{\n    width: 100vw;\n    height: 100vh;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap :7rem;\n    padding: 0 2rem;\n}\n\n.img{\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n}\n\n.login-content{\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\talign-items: center;\n\ttext-align: center;\n}\n\n.img img{\n\twidth: 1500px;\n\tmargin-bottom: 120px;\n\tmargin-left: 30px;\n}\n\nform{\n\twidth: 360px;\n\tdisplay: flex;\n\tflex-direction: column;\n\t\n}\n\n.error{\n\tpadding: 20px;\n\tmargin-bottom: 20px;\n\tbackground-color: rgb(254 202 202);\n\tborder:1px solid rgb(244, 158, 158);\n\tanimation: moveLeftToRight 1s ease-in-out ;\n\tdisplay: flex;\n\tcolor: darkslategray;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n@keyframes moveLeftToRight {\n\t0% {\n\t  transform: translateX(100px);\n\t}\n\t100% {\n\t  transform: translateX(0px); /* Adjust the distance as needed */\n\t}\n  }\n\n\n.login-content img{\n    height: 100px;\n\t\n}\n\n.login-content h2{\n\tmargin: 15px 0;\n\tcolor: #333;\n\ttext-transform: uppercase;\n\tfont-size: 2.9rem;\n}\n\n.login-content .input-div{\n\tposition: relative;\n    display: grid;\n    grid-template-columns: 7% 93%;\n    margin: 25px 0;\n    padding: 5px 0;\n    border-bottom: 2px solid #d9d9d9;\n}\n\n.login-content .input-div.one{\n\tmargin-top: 0;\n}\n\n.i{\n\tcolor: #d9d9d9;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.i i{\n\ttransition: .3s;\n}\n\n.input-div > div{\n    position: relative;\n\theight: 45px;\n}\n\n.input-div > div > h5{\n\tposition: absolute;\n\tleft: 10px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tcolor: #999;\n\tfont-size: 18px !important;\n\ttransition: .3s;\n}\n\n.input-div:before, .input-div:after{\n\tcontent: '';\n\tposition: absolute;\n\tbottom: -2px;\n\twidth: 0%;\n\theight: 2px;\n\tbackground-color: #38d39f;\n\ttransition: .4s;\n}\n\n.input-div:before{\n\tright: 50%;\n}\n\n.input-div:after{\n\tleft: 50%;\n}\n\n.input-div.focus:before, .input-div.focus:after{\n\twidth: 50%;\n}\n\n.input-div.focus > div > h5{\n\ttop: -5px;\n\tfont-size: 15px;\n}\n\n.input-div.focus > .i > i{\n\tcolor: #38d39f;\n}\n\n.input-div > div > input{\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tborder: none;\n\toutline: none;\n\tbackground: none;\n\tpadding: 0.5rem 0.7rem;\n\tfont-size: 1.2rem;\n\tcolor: #555;\n\tfont-family: 'poppins', sans-serif;\n}\n\n.input-div.pass{\n\tmargin-bottom: 4px;\n}\n\na{\n\tdisplay: block;\n\ttext-align: right;\n\ttext-decoration: none;\n\tcolor: #999;\n\tfont-size: 0.9rem;\n\ttransition: .3s;\n}\n\na:hover{\n\tcolor: #38d39f;\n}\n\n.btn{\n\tdisplay: block;\n\twidth: 100%;\n\theight: 50px;\n\tborder-radius: 25px;\n\toutline: none;\n\tborder: none;\n\tbackground-image: linear-gradient(to right, #32be8f, #38d39f, #32be8f);\n\tbackground-size: 200%;\n\tfont-size: 1.2rem;\n\tcolor: #fff;\n\tfont-family: 'Poppins', sans-serif;\n\ttext-transform: uppercase;\n\tmargin: 1rem 0;\n\tcursor: pointer;\n\ttransition: .5s;\n}\n.btn:hover{\n\tbackground-position: right;\n}\n\n\n@media screen and (max-width: 1050px){\n\t.container{\n\t\tgrid-gap: 5rem;\n\t}\n}\n\n@media screen and (max-width: 1000px){\n\tform{\n\t\twidth: 290px;\n\t}\n\n\t.login-content h2{\n        font-size: 2.4rem;\n        margin: 8px 0;\n\t}\n\n\t.img img{\n\t\twidth: 400px;\n\t}\n}\n\n@media screen and (max-width: 900px){\n\t.container{\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t.img{\n\t\tdisplay: none;\n\t}\n\n\t.wave{\n\t\tdisplay: none;\n\t}\n\n\t.login-content{\n\t\tjustify-content: center;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
